import { Middleware, configureStore, StoreEnhancer } from "@reduxjs/toolkit";
import { rootReducer } from "@/data/store/reducers";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // localStorage
import APIErrors from "../middleware/APIErrors";
import socketMiddleware from "../middleware/sockets";

export interface StoreConfig {
  middleware: Middleware[];
  enhancers?: StoreEnhancer[];
}

export function configureAppStore({ middleware, enhancers = [] }: StoreConfig) {

  const persistConfig = {
    key: "root",
    storage,
    whitelist: ["session"], 
    throttle: 1000, 
    serialize: true, 
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = configureStore({
    reducer: persistedReducer,

    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [
            "persist/PERSIST",
            "persist/REHYDRATE",
            // The Excel export resolves to a Blob and the import carries a
            // File. Neither is ever put in the store — they pass through the
            // thunk on their way to a download or an upload.
            "naeras/exportBids/fulfilled",
            "naeras/importBids/pending",
            "naeras/importBids/fulfilled",
            "naeras/importBids/rejected",
          ],
        },
      }).concat(middleware),
    enhancers: (getDefaultEnhancers) => {
      return getDefaultEnhancers().concat(enhancers);
    },
  });

  const persistor = persistStore(store);

  return { store, persistor };
}

const middleware = [APIErrors, socketMiddleware];

export const { store, persistor } = configureAppStore({
  middleware,
});

export type AppDispatch = typeof store.dispatch;
